import { useCallback, useEffect, useRef, useState } from "react";
import {  Box, Stack, Text } from "@chakra-ui/react";
import { FaGoogle } from "react-icons/fa";
import * as Yup from 'yup';
import { v4 as uuid } from 'uuid';
import SearchGoogle from "../../SearchGoogle";
import { geocodeByPlaceId, getLatLng } from "react-google-places-autocomplete";
import { FormHandles } from "@unform/core";

import api from "../../../services/api";
import { useAuth } from "../../../hooks/auth";
import Input from "../../Inputs/Input";
import getValidationErrors from '../../../utils/getValidationErrors';

import { Container, Content, ContentData, FormView, Buttons } from './styles';

type EndFormData = {
	id: string;
	cep: string;
	uf: string;
	cid: string;
	cidcod: string;
	bai: string;
	endereco: string;
	num: string;
	comp: string;
	ponto_ref: string;
	emp_cod: string;
};
interface AddEndClienteModalProps {
	onClose: (close: boolean) => void;
	isVisible: boolean;
	setEnderecos: (enderecos: EndFormData[]) => void;
	enderecos: EndFormData[];
	endModal: EndFormData;
	setEndModal: (end: EndFormData) => void;
};

const AddEndClienteModal: React.FC<AddEndClienteModalProps> = ({
	onClose = () => {},
	isVisible,
	setEnderecos,
	enderecos,
	endModal,
	setEndModal,
}) => {
	const formRefEndereco = useRef<FormHandles>(null);

	const { company, token } = useAuth();

	const [visible, setVisible] = useState(isVisible);

	function handleOnClose() {
		setVisible(false);
		setTimeout(() => {
			onClose(false);
		}, 300);
	};

	useEffect(() => {
		if (!endModal.id) {
			formRefEndereco.current?.reset();
		}
	}, []);

	function handleMasktCep(event: string) {
		let res = event;
		res = res.replace(/[A-Za-z]/g, '');
		formRefEndereco.current?.setFieldValue('cep', res);
	};

	async function handleCep(value: string, isGoogleSearch: boolean) {
		let cep = value;
		// Verifica se campo cep possui valor informado
		if (cep !== '' || cep !== undefined || cep !== null) {
			cep = cep.replace(/\D/g, '');
			// Expressão regular para validar o CEP.
			const validacep = /^[0-9]{8}$/;
			// Valida o formato do CEP.
			if (validacep.test(cep)) {
				// delete api.defaults.headers.authorization;
				// delete api.defaults.headers.company;
        delete api.defaults.headers.common['Authorization'];
        delete api.defaults.headers.common['company'];

				await api
					.get(`https://viacep.com.br/ws/${cep}/json`, { headers: {"Access-Control-Allow-Origin": "*"} })
					.then(response => {
						if (!isGoogleSearch) {
							formRefEndereco.current?.setFieldValue('cid', response.data.localidade);
							formRefEndereco.current?.setFieldValue('bai', response.data.bairro);
							formRefEndereco.current?.setFieldValue('endereco', response.data.logradouro);
							formRefEndereco.current?.setFieldValue('uf', response.data.uf);
							formRefEndereco.current?.setFieldValue('comp', response.data.complemento);
							formRefEndereco.current?.getFieldRef('num').focus();
						};

						formRefEndereco.current?.setFieldValue('cidcod', response.data.ibge);
					})
					.catch(err => {
						/* addToast({
							type: 'error',
							title: 'Erro no CEP',
							description: `ERROR - ${err}`,
						}); */
					})
					.finally(() => {
						// api.defaults.headers.authorization = `Bearer ${token}`;
						// api.defaults.headers.company = company.id;
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            api.defaults.headers.common['company'] = company.id;
					});

			} else {
				/* addToast({
					type: 'error',
					title: 'Erro no CEP',
					description: 'CEP digitado é inválido.',
				}); */
			}
		}
	};

	async function onLocationSelected(data: any) {
		await geocodeByPlaceId(data.value.place_id)
			.then(results => {
				const end = results[0].address_components;
				handleCep(end.length === 7 ? end[6].short_name : end.length === 6 ? end[5].short_name : '', true);
				formRefEndereco.current?.setFieldValue('cep', end.length === 7 ? end[6].short_name : end.length === 6 ? end[5].short_name : '');
				formRefEndereco.current?.setFieldValue('uf', end.length === 7 ? end[4].short_name : end.length === 6 ? end[3].short_name : '');
				formRefEndereco.current?.setFieldValue('cid', end.length === 7 ? end[3].short_name : end.length === 6 ? end[2].short_name : '');
				formRefEndereco.current?.setFieldValue('bai', end.length === 7 ? end[2].short_name : end.length === 6 ? end[1].short_name : '');
				formRefEndereco.current?.setFieldValue('endereco', end.length === 7 ? end[1].short_name : end.length === 6 ? end[0].short_name : '');
				formRefEndereco.current?.setFieldValue('num', end.length === 7 ? end[0].short_name : '');
				formRefEndereco.current?.getFieldRef(end.length === 7 ? 'comp' : 'num').focus();[]

				return results;
			})
			.then(results => getLatLng(results[0]))
	};

	async function handleSubmitEndereco(form: any) {
		try {
			formRefEndereco.current?.setErrors({});

			const schema = Yup.object().shape({
				cep: Yup.string().required('Cep obrigatório.'),
				uf: Yup.string().required('Estado obrigatório.'),
				cid: Yup.string().required('Cidade obrigatório.'),
				cidcod: Yup.string().required(),
				bai: Yup.string().required('Bairro obrigatório.'),
				endereco: Yup.string().required('Endereço obrigatório.'),
				num: Yup.string().required('Número obrigatório.'),
				comp: Yup.string(),
				ponto_ref: Yup.string(),
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			if (endModal.id) {
				const endIndex = enderecos.findIndex(end => end.id === endModal.id);
				enderecos[endIndex] = { ...form };
				setEnderecos(enderecos);
			} else {
				const endereco = { ...form, id: uuid(), emp_cod: company.id };
				setEnderecos([...enderecos, endereco]);
			}

			setEndModal({} as EndFormData);
			formRefEndereco.current?.reset();
			handleOnClose();
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefEndereco.current?.setErrors(errors);
			}
		}
	};

	return (
		<Container id="AddEndClienteModal">
			<Content className={`${visible ? 'active' : ''}`}>
				<Text fontSize={20} fontWeight={600} p={4}>Novo Endereço de Cliente</Text>

				<ContentData>
					<FormView ref={formRefEndereco} initialData={endModal} onSubmit={handleSubmitEndereco}>
						<Stack>
							<Box mb="4">
								<SearchGoogle
									onLocationSelected={onLocationSelected}
									label="Buscar Endereço"
									icon={FaGoogle}
								/>
							</Box>

							{/* CEP */}
							<Stack w="100%" spacing={2} direction="column">
								{/* CEP */}
								<div className="input">
									<p>Cep <span>(obrigatório)</span></p>
									<Input
										name="cep"
										placeholder="CEP"
										onChange={(e: any) => handleMasktCep(e.target.value)}
										onBlur={e => handleCep(e.target.value, false)}
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>
							</Stack>

							{/* CIDADE - ESTADO */}
							<Stack w="100%" spacing={2} direction="row">
								{/* CIDADE */}
								<div className="input">
									<p>Cidade <span>(obrigatório)</span></p>
									<Input
										name="cid"
										placeholder="Cidade"
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>

								{/* ESTADO */}
								<div className="input">
									<p>Estado <span>(obrigatório)</span></p>
									<Input
										name="uf"
										placeholder="Estado"
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>
							</Stack>

							{/* BAIRRO */}
							<Stack w="100%" spacing={2} direction="column">
								{/* BAIRRO */}
								<div className="input">
									<p>Bairro <span>(obrigatório)</span></p>
									<Input
										name="bai"
										placeholder="Bairro"
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>
							</Stack>

							{/* ENDERECO */}
							<Stack w="100%" spacing={2} direction="column">
								{/* ENDERECO */}
								<div className="input">
									<p>Endereço <span>(obrigatório)</span></p>
									<Input
										name="endereco"
										placeholder="Endereço"
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>
							</Stack>

							{/* NÚMERO - COMPLEMENTO */}
							<Stack w="100%" spacing={2} direction="row">
								{/* NÚMERO */}
								<div className="input">
									<p>Número <span>(obrigatório)</span></p>
									<Input
										name="num"
										type="number"
										placeholder="Número"
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>

								{/* COMPLEMENTO */}
								<div className="input">
									<p>Complemento</p>
									<Input
										name="comp"
										placeholder="Complemento"
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>
							</Stack>

							{/* PONTO DE REFERÊNCIA */}
							<Stack w="100%" spacing={2} direction="row">
								{/* PONTO DE REFERÊNCIA */}
								<div className="input">
									<p>Ponto de referência</p>
									<Input
										name="ponto_ref"
										placeholder="Ponto de referência"
										containerStyle={{ padding: '6px 0 6px 10px' }}
									/>
								</div>

								<Input
									name="cidcod"
									placeholder="Ponto de referência"
									containerStyle={{ padding: '6px 0 6px 10px', display: 'none', visibility: 'hidden' }}
								/>
							</Stack>
						</Stack>
					</FormView>
				</ContentData>

				<Buttons>
					<button
						type="button"
						className="button-cancel"
						onClick={handleOnClose}
					>
						Cancelar
					</button>

					<button
						type="submit"
						className="button-save"
						onClick={() => formRefEndereco.current?.submitForm()}
					>
						Adicionar
					</button>
				</Buttons>
			</Content>
		</Container>
	)
}

export default AddEndClienteModal;
